export default __webpack_public_path__ + "static/media/users.e382f363.svg";